import React, {useState, lazy, Suspense} from 'react';
import {createPortal} from 'react-dom';
import clsx from 'clsx';
import {Trans} from '@ui/i18n/trans';
import {useTrans} from '@ui/i18n/use-trans';
import {message} from '@ui/i18n/message';

const AiRecommendModal = lazy(() =>
  import('./ai-recommend-modal').then(m => ({default: m.AiRecommendModal})),
);

export function AiRecommendButton() {
  const [open, setOpen] = useState(false);
  const {trans} = useTrans();

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={clsx(
          'ai-recommend-btn group relative flex items-center gap-6 overflow-hidden rounded-full',
          'border border-yellow-400/25 bg-yellow-400/[0.08] px-12 py-6 lg:px-14 lg:py-7',
          'text-13 font-bold text-yellow-300 transition-all duration-300',
          'hover:border-yellow-400/40 hover:bg-yellow-400/[0.14] hover:shadow-[0_0_24px_-6px_rgba(250,204,21,0.3)]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/60',
          'active:scale-95',
        )}
        aria-label={trans(message('Bugün Ne İzlesem?'))}
      >
        <span className="ai-sparkle-glow relative flex h-16 w-16 items-center justify-center">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="relative z-10">
            <path d="M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 16.9L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z" />
          </svg>
        </span>
        <span className="hidden whitespace-nowrap sm:inline">
          <Trans message="Ne İzlesem?" />
        </span>
        <span className="inline whitespace-nowrap sm:hidden">AI</span>
      </button>

      {open &&
        createPortal(
          <Suspense fallback={null}>
            <AiRecommendModal open={open} onClose={() => setOpen(false)} />
          </Suspense>,
          document.body,
        )}
    </>
  );
}
